/**
 * @generated SignedSource<<77113788a2a6051e11c2b7a31ee794dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StoreUserPreferenceInput = {
  key: string;
  value?: string | null;
  valueJson?: string | null;
};
export type updateUserPreferenceMutation$variables = {
  input: StoreUserPreferenceInput;
};
export type updateUserPreferenceMutation$data = {
  readonly storeUserPreference: {
    readonly preference: {
      readonly key: string | null;
      readonly value: string | null;
      readonly valueJson: string | null;
    };
  } | null;
};
export type updateUserPreferenceMutation = {
  variables: updateUserPreferenceMutation$variables;
  response: updateUserPreferenceMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StoreUserPreferencePayload",
    "kind": "LinkedField",
    "name": "storeUserPreference",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserPreference",
        "kind": "LinkedField",
        "name": "preference",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "valueJson",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateUserPreferenceMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateUserPreferenceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "abfa7fdc87ccb6062cda988f25fc7fbd",
    "id": null,
    "metadata": {},
    "name": "updateUserPreferenceMutation",
    "operationKind": "mutation",
    "text": "mutation updateUserPreferenceMutation(\n  $input: StoreUserPreferenceInput!\n) {\n  storeUserPreference(input: $input) {\n    preference {\n      key\n      value\n      valueJson\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ecbca8f033adde163c6c0d3aad05289";

export default node;
